/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { REPAIR_COSTS_SCALE_WITH_BUILDING_VALUE } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import BuildingLayoutSection from './BuildingLayoutSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { selectFormFieldVisibility } = modelTypesByForm[ownProps.form];
  return {
    showRepairCostsScaleWithBuildingValue: selectFormFieldVisibility(state)(
      REPAIR_COSTS_SCALE_WITH_BUILDING_VALUE
    ),
  };
};

export default connect(mapStateToProps)(BuildingLayoutSection);
